import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

// Supabase client oluşturma
let supabase;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables!');
  console.error('REACT_APP_SUPABASE_URL:', supabaseUrl);
  console.error('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'Present' : 'Missing');
  console.error('');
  console.error('🔧 To fix this:');
  console.error('1. Create a Supabase project at https://supabase.com');
  console.error('2. Create a .env file in the frontend directory with:');
  console.error('   REACT_APP_SUPABASE_URL=your_supabase_project_url');
  console.error('   REACT_APP_SUPABASE_ANON_KEY=your_supabase_anon_key');
  console.error('');
  console.error('🚫 Application will not work without proper Supabase configuration.');
  
  // Create a mock client that throws errors
  supabase = {
    auth: {
      signInWithPassword: () => Promise.reject(new Error('Supabase not configured. Please set up environment variables.')),
      signUp: () => Promise.reject(new Error('Supabase not configured. Please set up environment variables.')),
      signOut: () => Promise.reject(new Error('Supabase not configured. Please set up environment variables.')),
      getUser: () => Promise.reject(new Error('Supabase not configured. Please set up environment variables.'))
    },
    from: () => ({
      select: () => Promise.reject(new Error('Supabase not configured. Please set up environment variables.')),
      insert: () => Promise.reject(new Error('Supabase not configured. Please set up environment variables.')),
      update: () => Promise.reject(new Error('Supabase not configured. Please set up environment variables.')),
      delete: () => Promise.reject(new Error('Supabase not configured. Please set up environment variables.'))
    })
  };
} else {
  // Normal Supabase client oluştur - İyileştirilmiş konfigürasyon
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'celiktas-auth-token',
      flowType: 'pkce'
    },
    global: {
      headers: {
        'x-application-name': 'celiktas-pos'
      }
    },
    db: {
      schema: 'public'
    },
    realtime: {
      params: {
        eventsPerSecond: 2
      }
    }
  });
}

// Test Supabase connection (removed in production)

// Export the configured Supabase client
export { supabase };
export default supabase;
